import * as api from "../../api/generated-api";
import { TitledGrid } from "../common/TitledGrid";
import { Grid, Stack, Typography } from "@mui/material";
import React from "react";

type CompanyMembersProps = {
  title: string;
  people: api.Person[];
};

export const CompanyMembers = (props: CompanyMembersProps) => {
  const { title, people = [] } = props;

  return (
    <TitledGrid title={title}>
      <Grid item xs={6}>
        <Stack>
          {!!people.length && (
            <Typography variant={"subtitle2"}>Name</Typography>
          )}
          {people.map((person) => {
            return (
              <Typography key={person.id + "_name"} variant={"body1"}>
                {person.firstName} {person.lastName}
              </Typography>
            );
          })}
        </Stack>
      </Grid>
      <Grid item xs={6}>
        <Stack>
          {!!people.length && (
            <Typography variant={"subtitle2"}>Email</Typography>
          )}
          {people.map((person) => {
            return (
              <Typography key={person.id + "_email"} variant={"body1"}>
                <a href={`mailto:${person.email}`}>{person.email}</a>
              </Typography>
            );
          })}
        </Stack>
      </Grid>
    </TitledGrid>
  );
};
